import httpClient from '../../api/config';

export default {
    namespaced: true,

    state: {
        integrations: []
    },

    mutations: {
        SET_INTEGRATIONS(state, integrations) {
            state.integrations = integrations;
        }
    },

    actions: {
        getConnectUrl(_, { monitorId, returnTo }) {
            return httpClient.get(`/v2/facebook/connect?monitor_id=${monitorId}&return_to=${returnTo}`)
                .then(response => response.data);
        },
        fetchIntegrations({ commit }, monitorId) {
            return httpClient.get(`/v2/facebook/pages?monitor_id=${monitorId}`)
                .then(response => {
                    commit('SET_INTEGRATIONS', response.data.pages || []);
                });
        },
        connectPage(_, { monitorId, pageId }) {
            return httpClient.patch(`/v2/facebook/pages/${pageId}/connect`, { monitor_id: monitorId });
        },
        disconnect(_, { monitorId, pageId }) {
            return httpClient.delete(`/v2/facebook/pages/${pageId}`, { data: { monitor_id: monitorId } });
        }
    },

    getters: {}
};
